@if (videoType(); as videoType) { @if (videoType === 'embedded') { @if (iframeHtml()) {
<div class="ui-video-wrapper" [innerHtml]="iframeHtml()"></div>
} @if (!iframeHtml() && showErrorForInvalidUrl()) {
<div>
	<lib-message [type]="'warning'">Invalid video URL</lib-message>
</div>
} } }
